// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-phone-code[data-v-270f2915] {
  padding-top: 1rem;
  padding-bottom: 1rem;
  min-width: 6rem;
}
.select-container[data-v-270f2915] {
  padding: 0.5rem 1.75rem 0.5rem 1rem;
  position: relative;
}
.select-tag[data-v-270f2915] {
  border-bottom: 1px solid var(--input-color);
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 1;
}
select[data-v-270f2915] {
  font-weight: var(--text-font-weight);
  opacity: 0;
  border: none;
  outline: none;
  height: 100%;
}
span[data-v-270f2915] {
  color: var(--text-contrast-color);
  overflow: hidden;
  font-weight: 400;
  text-align: center;
}
select[data-v-270f2915],
span[data-v-270f2915] {
  font-family: var(--primary-font);
  font-size: 1rem;
  line-height: 1.25;
  display: block;
  width: 100%;
}
.select-container[data-v-270f2915]::after {
  content: '';
  position: absolute;
  top: 0.6875rem;
  right: 0.5rem;
  height: 0.75rem;
  width: 0.75rem;
  border-left: 1px solid var(--input-color);
  border-bottom: 1px solid var(--input-color);
  transform: rotate(-45deg);
}
select[data-v-270f2915]:hover {
  cursor: pointer;
}
.select-disabled[data-v-270f2915] {
  opacity: 0.5;
}
select[data-v-270f2915]:disabled {
  cursor: default;
}
.has-error.ui-touched[data-v-270f2915] {
  --input-color: var(--error);
  --dark: var(--error);
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiPhoneCode.vue"],"names":[],"mappings":";AAkGA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AACA;AAEA;EACA,mCAAA;EACA,kBAAA;AACA;AAEA;EACA,2CAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;AACA;AAEA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACA;AAEA;;EAEA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,yCAAA;EACA,2CAAA;EACA,yBAAA;AACA;AAEA;EACA,eAAA;AACA;AAEA;EACA,YAAA;AACA;AAEA;EACA,eAAA;AACA;AAEA;EACA,2BAAA;EACA,oBAAA;AACA","sourcesContent":["<template>\n  <div class=\"ui-phone-code\" :class=\"[{ 'has-error': error }, touchedClass]\">\n    <div class=\"select-container\" :class=\"{ 'select-disabled': disabled }\">\n      <div class=\"select-tag\">\n        <select\n          ref=\"select\"\n          :value=\"value\"\n          :disabled=\"disabled\"\n          @change=\"valueChange\"\n          @blur=\"lostFocus\"\n        >\n          <option value=\"\" hidden />\n          <option\n            v-for=\"item in phoneCodes\"\n            :key=\"item.key\"\n            :value=\"item.value\"\n          >\n            {{ item.name }}\n          </option>\n        </select>\n      </div>\n      <span>{{ value ? '+' : '-' }}{{ value }}</span>\n    </div>\n  </div>\n</template>\n\n<script>\nimport PhoneCodes from '@src/scripts/phone-codes'\n\nexport default {\n  name: 'ui-phone-code',\n\n  props: {\n    value: { type: String, default: undefined },\n    country: { type: String, default: undefined },\n    error: Boolean,\n    disabled: Boolean\n  },\n\n  data() {\n    return {\n      isTouched: false\n    }\n  },\n\n  computed: {\n    phoneCodes() {\n      const phoneCodes = PhoneCodes\n\n      for (const item of phoneCodes) {\n        const country = this.$t(`Countries.${item.key}`)\n        item.name = `${country} (+${item.value})`\n      }\n\n      phoneCodes.sort(({ name: i1 }, { name: i2 }) =>\n        i1 > i2 ? 1 : i1 < i2 ? -1 : 0\n      )\n\n      return phoneCodes\n    },\n\n    touchedClass() {\n      return this.isTouched ? 'ui-touched' : 'ui-untouched'\n    }\n  },\n\n  mounted() {\n    const { country, value, phoneCodes } = this\n\n    let phoneData = null\n    if (value) {\n      phoneData = phoneCodes.find((item) => item.value === value)\n    }\n\n    if (!phoneData) {\n      if (!country) return\n\n      phoneData = phoneCodes.find((item) => item.key === country)\n      if (!phoneData) return\n    }\n\n    this.$emit('input', phoneData.value)\n  },\n\n  methods: {\n    valueChange(event) {\n      const { value } = event.target\n      this.$emit('input', value)\n    },\n\n    lostFocus() {\n      this.isTouched = true\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-phone-code {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  min-width: 6rem;\n}\n\n.select-container {\n  padding: 0.5rem 1.75rem 0.5rem 1rem;\n  position: relative;\n}\n\n.select-tag {\n  border-bottom: 1px solid var(--input-color);\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  z-index: 1;\n}\n\nselect {\n  font-weight: var(--text-font-weight);\n  opacity: 0;\n  border: none;\n  outline: none;\n  height: 100%;\n}\n\nspan {\n  color: var(--text-contrast-color);\n  overflow: hidden;\n  font-weight: 400;\n  text-align: center;\n}\n\nselect,\nspan {\n  font-family: var(--primary-font);\n  font-size: 1rem;\n  line-height: 1.25;\n  display: block;\n  width: 100%;\n}\n\n.select-container::after {\n  content: '';\n  position: absolute;\n  top: 0.6875rem;\n  right: 0.5rem;\n  height: 0.75rem;\n  width: 0.75rem;\n  border-left: 1px solid var(--input-color);\n  border-bottom: 1px solid var(--input-color);\n  transform: rotate(-45deg);\n}\n\nselect:hover {\n  cursor: pointer;\n}\n\n.select-disabled {\n  opacity: 0.5;\n}\n\nselect:disabled {\n  cursor: default;\n}\n\n.has-error.ui-touched {\n  --input-color: var(--error);\n  --dark: var(--error);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
